module.exports = __webpack_public_path__ + "static/img/1.e279dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newFour/1.png
// module id = xcyZ
// module chunks = 0